
import React from 'react';
import { withRouter } from 'react-router-dom';

import '../main.css';

import { auth } from '../firebase';

const SignOutButton = ({history}) => 
  <div>
        <SignOut history = {history} />
  </div>


class SignOut extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state = {
      error:''
    }
  }

  handleSignOut()
  {
    var self = this;
    auth.doSignOut().then( () => {
      self.props.history.push('/');
    }).catch( (error) => {
      self.setState({
        error: error
      })
    });
  }
  
  render(){
    var error = this.state.error;
    return(
      <div>
        <button className="logOutBtn"
            type="button"
            onClick={this.handleSignOut.bind(this)}
          >
            Sign Out
          </button>
        { error && <p>{error.message}</p> }
    </div>
    )
  }
}

export default withRouter(SignOutButton);



// WEBPACK FOOTER //
// ./src/components/SignOut.js